export var LocaleCodes;
(function (LocaleCodes) {
    LocaleCodes["EN_US"] = "en-US";
    LocaleCodes["FR_CA"] = "fr-CA";
    LocaleCodes["EN_CA"] = "en-CA";
    LocaleCodes["EN_GB"] = "en-GB";
    LocaleCodes["FR_FR"] = "fr-FR";
    LocaleCodes["DE_DE"] = "de-DE";
    LocaleCodes["IT_IT"] = "it-IT";
    LocaleCodes["ES_ES"] = "es-ES";
    LocaleCodes["EN"] = "en";
    LocaleCodes["ES"] = "es";
    LocaleCodes["FR"] = "fr";
})(LocaleCodes || (LocaleCodes = {}));
//# sourceMappingURL=LocaleCodes.js.map